import axios from "axios";
import { itemAction } from "../actionTypes";
import { url } from "../../config/config";

export const itemListInitiate = () => ({ type: itemAction.ITEM_LIST_INITIATE })
export const itemListSuccess = (data) => ({ type: itemAction.ITEM_LIST_SUCCESS, payload: data })
export const itemListFailure = () => ({ type: itemAction.ITEM_LIST_FAILURE })
export const itemOptionsSuccess = (data) => ({ type: itemAction.ITEM_OPTIONS_SUCCESS, payload: data })

export function getItemList(params) {
    return async dispatch => {
        dispatch(itemListInitiate())
        try {
            const { data } = await axios.get(`${url}items`, { params })
            dispatch(itemListSuccess(data))
            return data
        } catch (err) {
            dispatch(itemListFailure())
            throw err
        }
    }
}

export function getItemOptions() {
    return async dispatch => {
        const { data } = await axios.get(`${url}items/options`)
        dispatch(itemOptionsSuccess(data))
        return data
    }
}

// Create/update/delete resolve with the API response; the page refreshes the list afterwards.
export function saveItem(item) {
    return async () => {
        const { _id, ...body } = item
        const { data } = _id
            ? await axios.put(`${url}items/${_id}`, body)
            : await axios.post(`${url}items`, body)
        return data
    }
}

export function deleteItem(id) {
    return async () => {
        const { data } = await axios.delete(`${url}items/${id}`)
        return data
    }
}

export function getItemNames() {
    return async () => {
        const { data } = await axios.get(`${url}items/names`)
        return data
    }
}

export function getCompanyNames() {
    return async () => {
        const { data } = await axios.get(`${url}items/companies`)
        return data
    }
}

export function getCompanyItems(params) {
    return async () => {
        const { data } = await axios.get(`${url}items/by-company`, { params })
        return data
    }
}

export function getPriceAnalysis(params) {
    return async () => {
        const { data } = await axios.get(`${url}items/price-analysis`, { params })
        return data
    }
}
